import LanguageDetector from 'i18next-browser-languagedetector';
import { defaultLocale, localeCookie } from '../constants';
import Cookies from 'js-cookie';
import { checkLocale, getSupportedLocale } from './localePreference';

export const buildCustomLanguageDetector = () => {
  const customLanguageDetector = new LanguageDetector();
  customLanguageDetector.addDetector({
    name: 'customDetector',
    lookup(): string | undefined {
      const lngFromQuery = new URL(window.location.href).searchParams.get('lng');
      const lngFromLocalStorage = localStorage.getItem('userSelectedLng');
      const lngFromCookie = Cookies.get(localeCookie);

      // 1) Explicit query param always wins
      if (lngFromQuery) {
        const supported = getSupportedLocale(lngFromQuery);
        if (supported) {
          return supported;
        }
      }

      // 2) Manual user selection (language switcher) wins next
      if (lngFromLocalStorage) {
        const supported = getSupportedLocale(lngFromLocalStorage);
        if (supported) {
          return supported;
        }
      }

      // 3) Persisted cookie wins ONLY if it is not just the default locale.
      // This prevents a default `.culture=en-US` (often set implicitly) from overriding
      // a user's browser language settings.
      if (lngFromCookie && lngFromCookie !== defaultLocale) {
        const supported = getSupportedLocale(lngFromCookie);
        if (supported) {
          return supported;
        }
      }

      // 4) Browser language detection
      if (navigator.languages.length) {
        for (let locale of navigator.languages) {
          const normalizedLocale = locale === 'en' ? 'en-US' : locale;
          const checkedLocale = checkLocale(normalizedLocale);
          if (checkedLocale) {
            // Mark that browser language was detected (not a manual selection)
            if (typeof localStorage !== 'undefined' && !localStorage.getItem('userSelectedLng')) {
              // Only store the flag if the detected browser locale is non-default.
              // This allows default en-US browsers to still have locale follow country selection.
              if (checkedLocale !== defaultLocale) {
                localStorage.setItem('browserLanguageDetected', checkedLocale);
              }
            }
            return checkedLocale;
          }
        }
      }

      // 5) Final fallback
      return defaultLocale;
    }
  });

  return customLanguageDetector;
};
